module.exports = __webpack_public_path__ + "img/depmap_svg_V179.556902c4.svg";